define('community-threads-view',['controller', 'community-editor', 'socket', 'session', 'tooltip-notifier'],
function(controller, editor, socket, session, tooltipNotifier) {
	var thread_id;
	var new_posts_ids = new Array();
	
	// ======================== utils ========================
	
	// enables the buttons which open forms
	function enableFormOpeners() {
		$('.edit-button, .delete-button, .delete-thread-button, .move-thread-button').prop('disabled', false);
	}
	
	// disables the buttons which open forms
	function disableFormOpeners() {
		$('.edit-button, .delete-button, .delete-thread-button, .move-thread-button').prop('disabled', true);
	}
	
	// hides all delete/edit forms and re-enables buttons
	function closeAllForms() {
		$('.edit-form, .delete-form, .delete-thread-form, .move-thread-form').hide();
		$('.post-text, .post-edited').show();
		$('.edit-form, .delete-form, .move-thread-form, .delete-thread-form').data('form', false);
		
		editor.destroy();
		enableFormOpeners();
	}
	
	// ======================== edit post ========================
	
	function onEditClick() {
		var post = $(this).closest('.forum-post');
		var id = post.data('post-id');
		var text = post.find('.post-text').html();
		var form = post.find('.edit-form');
		
		disableFormOpeners(); // only one form can be open
		post.find('.post-text').hide(); // hide text when editor is open
		post.find('.post-edited').hide(); // hide last edited text also
		
		form.find('textarea').attr('id', 'editor-' + id).val(text);
		form.show();
		form.data('form', true);
		
		editor.initMCE('.edit-text-input-' + id);
	}
	
	function onEditFormSubmit(e) {
		e.preventDefault();

		var id = $(this).data('id');
		var text = editor.getContent().trim();
		var form = $(this);
		
		if (text == '')
			return;
		
		form.find('input[type=submit]').prop('disabled', true).val('Bearbeiten...');
		
		$.ajax({
			url: '/forum/-/0/' + id + '/edit',
			type: 'POST',
			dataType: 'json',
			data: {text: text}
		}).done(function(data) {
			//replace with new html
			$('.forum-post[data-post-id=' + data.post_id + '] .post-text').html(data.new_display_html);
			$('.forum-post[data-post-id=' + data.post_id + '] .post-edited').html(data.new_last_edited_html);

			closeAllForms();
		}).fail(function(xhr) {
			tooltipNotifier.showError(form, 'Fehler beim Bearbeiten des Beitrags.', xhr);
		}).always(function() {
			form.find('input[type=submit]').prop('disabled', false).val('Bearbeiten');
		});
	}
	
	// ======================== delete post ========================
	
	function onDeletePostClick() {
		var post = $(this).closest('.forum-post');
		var id = post.data('post-id');
		var form = post.find('.delete-form');
		
		form.show();
		form.data('form', true);
		disableFormOpeners();
	}
	
	function onDeletePostFormSubmit(e) {
		e.preventDefault();

		var button = $(this);
		var post = button.closest('.forum-post');
		var id = post.data('post-id');
		var form = post.find('.delete-form');
		
		var reason = form.find('textarea').val();
		var hide = form.find('input[type=checkbox]').prop('checked');
		if(hide)
			var url = '/forum/-/0/' + id + '/hide';
		else
			var url = '/forum/-/0/' + id + '/delete';
		
		form.find('input[type=submit]').prop('disabled', true).val('Löschen...');
		
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'json',
			data: {delete_reason: reason}
		}).done(function(data) {
			if(hide) {
				post.remove();
			} else {
				post.html(data.new_html);
				post.find('.restore-button').click(onRestorePostClick);
				post.find('.hide-button').click(onHideDeletedPostClick);
			}

			closeAllForms();
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Löschen des Beitrags.', xhr);
		}).always(function() {
			form.find('input[type=submit]').prop('disabled', false).val('Löschen');
		});
	}
	
	// ======================== restore post ========================
	
	function onRestorePostClick() {
		var button = $(this);
		var post = button.closest('.forum-post');
		var id = post.data('post-id');
		post.data('is-restoring', true);

		$.ajax({
			url: '/forum/-/0/' + id + '/show',
			type: 'GET',
			dataType: 'json'
		}).done(function(data) {
			$.ajax({
				url: '/forum/-/0/' + data.post_id + '/get',
				type: 'POST',
				dataType: 'json'
			}).done(function(data) {
				// replace whole post with new html
				$('.forum-post[data-post-id=' + data.post_id + ']').replaceWith(data.post_html);

				// set click handlers
				$('.forum-post[data-post-id=' + data.post_id + '] .edit-button').click(onEditClick);
				$('.forum-post[data-post-id=' + data.post_id + '] .delete-button').click(onDeletePostClick);
				$('.forum-post[data-post-id=' + data.post_id + '] .cancel-edit-form').click(closeAllForms);
				$('.forum-post[data-post-id=' + data.post_id + '] .cancel-delete-form').click(closeAllForms);
				$('.forum-post[data-post-id=' + data.post_id + '] .edit-form').submit(onEditFormSubmit);
				$('.forum-post[data-post-id=' + data.post_id + '] .delete-form').submit(onDeletePostFormSubmit);

				post.data('is-restoring', false);
			}).fail(function(xhr) {
				tooltipNotifier.showError(button, 'Fehler', xhr); // TODO better error message
			});
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Wiederherstellen des Beitrags', xhr);
		});
	}
	
	// ======================== hide deleted post ========================
	
	function onHideDeletedPostClick() {
		var button = $(this);
		var post = button.closest('.forum-post');
		var id = post.data('post-id');
		post.data('is-deleting', true);
		
		$.ajax({
			url: '/forum/-/0/' + id + '/hide',
			type: 'GET',
			dataType: 'json'
		}).done(function() {
			post.remove();
			post.data('is-deleting', false);
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Verstecken des Beitrags', xhr);
		});
	}
	
	// ======================== subscribe ========================
	
	function onSubscribeClick() {
		var button = $(this);
		var text = button.text();
		var id = button.data('id');
		
		button.prop('disabled', true).text(text + '...');
		
		$.ajax({
			url: '/forum/-/' + id + '/subscribe',
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			$('.subscribe-button').hide();
			$('.unsubscribe-button').show();
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, "Fehler beim Abonnieren dieses Themas", xhr);
		}).always(function() {
			button.prop('disabled', false).text(text);
		});
	}
	
	function onUnsubscribeClick() {
		var button = $(this);
		var text = button.text();
		var id = button.data('id');
		
		button.prop('disabled', true).text(text + '...');
		
		$.ajax({
			url: '/forum/-/' + id + '/unsubscribe',
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			$('.unsubscribe-button').hide();
			$('.subscribe-button').show();
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, "Fehler beim Deabonnieren dieses Themas", xhr);
		}).always(function() {
			button.prop('disabled', false).text(text);
		});
	}
	
	// ======================== load new posts ========================
	
	function onLoadClick() {
		var button = $(this);
		var old_post_count = $('#load').data('post-count');
		var load_count = 10 - $('#load').data('post-count');
		var last_post_id = $('#forum-thread-posts .forum-post').last().data('post-id');
		
		$.ajax({
			url: '/forum/-/' + thread_id + '/load',
			type: 'POST',
			data: {count: load_count, last_post_id: last_post_id},
			dataType: 'json'
		}).done(function(data) {
			var new_post_count = old_post_count + data.count;

			// set click handlers
			var html = $(data.html);
			$(html).find('.edit-button').click(onEditClick);
			$(html).find('.delete-button').click(onDeletePostClick);
			$(html).find('.cancel-edit-form').click(closeAllForms);
			$(html).find('.cancel-delete-form').click(closeAllForms);
			$(html).find('.edit-form').submit(onEditFormSubmit);
			$(html).find('.delete-form').submit(onDeletePostFormSubmit);

			$('#forum-thread-posts').append(html);
			$('#load').html('');

			$('#load').data('post-count', new_post_count);
			$('#load').data('new-posts', 0);
			new_posts_ids = new Array();
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Nachladen.', xhr);
		});
	}
	
	// ======================== moderation ========================
	
	function onDeleteThreadClick() {
		if(!$('.delete-thread-form').data('form')) {
			disableFormOpeners();
			
			$('.delete-thread-form').show();
			$('.delete-thread-form').data('form', true);
		}
	}
	
	function onMoveThreadClick() {
		if(!$('.move-thread-form').data('form')) {
			disableFormOpeners();
			
			$('.move-thread-form').show();
			$('.move-thread-form').data('form', true);
		}
	}
	
	// ======================== socket events ========================
	
	function onThreadSoftDelete(e) {
		if(!$('.forum-post[data-post-id=' + e.post_id + ']').find('.edit-form').data('form')) {
			var html = $(e.new_html);
			var post = $('.forum-post[data-post-id=' + e.post_id + ']');
			post.html(html);
			
			if(session.admin && post.find('.admin-deleted-post-menu').length == 0) { // event comes from non admin user
				var admin_menu = $('<div>').addClass('admin-deleted-post-menu');
				var restore_button = $('<button>')
										.addClass('link-button')
										.addClass('restore-button')
										.data('id', e.post_id)
										.html('Wiederherstellen');
				
				var hide_button = $('<button>')
										.addClass('link-button')
										.addClass('hide-button')
										.data('id', e.post_id)
										.html('Verstecken');
				
				admin_menu.append(restore_button);
				admin_menu.append(hide_button);
				post.find('.deleted-post').append(admin_menu);
				
				post.find('.restore-button').click(onRestorePostClick);
				post.find('.hide-button').click(onHideDeletedPostClick);
			}
		} else { //post is edited just now
			var post = $('.forum-post[data-post-id=' + e.post_id + ']');
			post.find('.submit-edit-form').prop('disabled', true);
			post.find('.edit-form').append('Achtung! Dieser Beitrag wurde von einem anderen Nutzer gelöscht, sichere gegebenenfalls deine Bearbeitung.');
		}
	}
	
	function onThreadHide(e) {
		if(!$('.forum-post[data-post-id=' + e.post_id + ']').find('.edit-form').data('form')) {
			if(new_posts_ids.indexOf(e.post_id) != -1) { // post is hidden in load button
				var button = $('#load').find('.load-button');
				var new_posts_count = $('#load').data('new-posts');
				$('#load').data('new-posts', new_posts_count - 1);
				
				if(new_posts_count == 1) {
					button.remove();
				} else if (new_posts_count == 2) {
					button.html((new_posts_count - 1) + ' Beitrag nachladen');
				} else {
					button.html((new_posts_count - 1) + ' Beiträge nachladen');
				}
			} else {
				$('.forum-post[data-post-id=' + e.post_id + ']').remove();
			}
		} else { //post is edited just now
			var post = $('.forum-post[data-post-id=' + e.post_id + ']');
			post.find('.submit-edit-form').prop('disabled', true);
			post.find('.edit-form').append('Achtung! Dieser Beitrag wurde von einem anderen Nutzer gelöscht, sichere gegebenenfalls deine Bearbeitung.');
		}
	}
	
	function onThreadEdit(e) {
		//replace with new html
		$('.forum-post[data-post-id=' + e.post_id + '] .post-text').html(e.new_display_html);
		$('.forum-post[data-post-id=' + e.post_id + '] .post-edited').html(e.new_last_edited_html);
	}

	
	function onThreadRestore(e) {
		var button = $(this);
		$.ajax({
			url: '/forum/-/0/' + e.post_id + '/get',
			type: 'POST',
			dataType: 'json'
		}).done(function(data) {
			// replace whole post with new html
			$('.forum-post[data-post-id=' + e.post_id + ']').replaceWith(data.post_html);

			// set click handlers
			$('.forum-post[data-post-id=' + e.post_id + '] .edit-button').click(onEditClick);
			$('.forum-post[data-post-id=' + e.post_id + '] .delete-button').click(onDeletePostClick);
			$('.forum-post[data-post-id=' + e.post_id + '] .cancel-edit-form').click(closeAllForms);
			$('.forum-post[data-post-id=' + e.post_id + '] .cancel-delete-form').click(closeAllForms);
			$('.forum-post[data-post-id=' + e.post_id + '] .edit-form').submit(onEditFormSubmit);
			$('.forum-post[data-post-id=' + e.post_id + '] .delete-form').submit(onDeletePostFormSubmit);
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Wiederherstellen des Threads.', xhr);
		});
	}
	
	controller.on('community/threads/view', function() {
		thread_id = $('#forum-thread-posts').data('thread-id');
		
		$('.cancel-edit-form, .cancel-delete-form, .cancel-delete-thread-form, .cancel-move-thread-form').click(closeAllForms);
		
		$('.edit-button').click(onEditClick);
		$('.delete-button').click(onDeletePostClick);
		$('.restore-button').click(onRestorePostClick);
		$('.hide-button').click(onHideDeletedPostClick);
		$('.edit-form').submit(onEditFormSubmit);
		$('.delete-form').submit(onDeletePostFormSubmit);
		
		$('.delete-thread-button').click(onDeleteThreadClick);
		$('.move-thread-button').click(onMoveThreadClick);
		$('.subscribe-button').click(onSubscribeClick);
		$('.unsubscribe-button').click(onUnsubscribeClick);
		
		socket.on('thread-' + thread_id + '-soft-delete', onThreadSoftDelete);
		socket.on('thread-' + thread_id + '-hide', onThreadHide);
		socket.on('thread-' + thread_id + '-edit', onThreadEdit);
		socket.on('thread-' + thread_id + '-restore', onThreadRestore);
	}, function() {
		socket.off('thread-' + thread_id + '-soft-delete', onThreadSoftDelete);
		socket.off('thread-' + thread_id + '-hide', onThreadHide);
		socket.off('thread-' + thread_id + '-edit', onThreadEdit);
		socket.off('thread-' + thread_id + '-restore', onThreadRestore);
	});
});

